import { getConfiguration } from "./configuration";
import { isEntityToBeHiddenByDesc } from "./isEntityToBeHiddenByDesc";

export function isCategoryToBeHidden(categoryId, desc) {
	let toHide = false;
	const entityRules = getConfiguration().eruls;
	if (entityRules != null) {
		const map = entityRules.hcts;
		const hiddenById = map != null && map[categoryId] != null;
		toHide = hiddenById || isEntityToBeHiddenByDesc(desc);
	}
	return toHide;
}
